export const DEFAULT_LOCALE = 'en' as const;
